import React, { Component } from 'react';

//import { History } from '../../helpers/History';
import PropTypes from 'prop-types';
//import Swal from 'sweetalert2';
import { connect } from 'react-redux';
// import {History} from '../../helpers';
import { logout } from '../state/actions/AuthActions';

//import { Redirect } from 'react-router-dom';

/*document.addEventListener('idle', () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.signInUserSession) {
        Swal({
            title: 'Your session has ended due to inactivity',
            type: 'failure',
            footer: 'You will be redirected to the signin screen in a few moments.',
            showConfirmButton: false,
        });
        setTimeout(() => {
            History.push('/logout');
        }, 3000);
    }
});*/

class LogoutPage extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    componentDidMount() {
        console.log('Logout');
        this.props.dispatch(logout());
        localStorage.removeItem('user');
        window.location.reload();
    }

    render() {
        return <div>You have been logged out.</div>;
    }
}

const hoc = connect()(LogoutPage);

// EXPORT COMPONENT

export { hoc as LogoutPage };
